var productGrid = function() {
return {

	bindToController: {
		items: '<productGrid'
	},
	controller: function($scope) {
		
		//this.items = $scope.refCtrl.items;
		this.opensNewGroup = function(index) {
			if (index == 0) return true;
			return this.items[index-1].sg_product.sg_product_group != this.items[index].sg_product.sg_product_group;
		}
		this.rowSpan = function(index) {
			var group = this.items[index].sg_product.sg_product_group;
			var count = 0;
			var i;
			for (i=index-1; i>0 && this.items[i].sg_product.sg_product_group == group; i--) count++;
			for (i=index; i<this.items.length && this.items[i].sg_product.sg_product_group == group; i++) count++;
			return count;
		}
	},
	controllerAs: '$grid',
}}

angular.module('forms')
.directive('productGrid', productGrid)


.filter('addGroup', function($parse) {
  return function( items, group_expression) {
    var filtered = [];
	var group_func = $parse(group_expression)
	var lastGroup = undefined;
	var lastGroupCount = 0;
	var lastGroupItems = [];
	var updateCount = function() {
		for (var i=0; i<lastGroupItems.length; i++) {
			lastGroupItems[i].count = lastGroupCount;
		}
	}
    angular.forEach(items, function(item) {
	  var group = group_func(item);
	  if (lastGroup != group) {
		  updateCount();
		  lastGroup = group;
		  lastGroupCount = 0;
		  lastGroupItems = [];
	  }
	  item.$group = {
		  index: lastGroupCount,
		  count: null,
	  }
	  lastGroupCount += 1;
	  lastGroupItems.push(item.$group)
      filtered.push(item);
    });
	updateCount();
    return filtered;
  };
});